import React from 'react';
import SvgArrowDown from '../../../../assets/svgs/arrow-down.svg';
import classNames from 'classnames/bind';
import styles from './styles.module.scss';

const cx = classNames.bind(styles);

function Button({
  type = 'default',
  disabled,
  showArrow = false,
  className,
  children,
  onClick,
  ...props
}) {
  return (
    <button
      onClick={onClick && !disabled ? onClick : null}
      className={cx(
        type === 'primary' && 'PrimaryButton',
        type === 'secondary' && 'SecondaryButton',
        type === 'default' && 'DefaultButton',
        { disabled },
        className,
      )}
      {...props}
    >
      {children}
      {showArrow && <SvgArrowDown />}
    </button>
  );
}

export default Button;
